define(function(require, exports, module) {

    var $ = require('common/j');
    var Deferred = require('deferred');
    const mathAlgorithms = require('util/math.util').algorithms;

    $.fn.scroll = function(XAxisPosition, YAxisPosition, duration, easingFunction, callback) {
        easingFunction = easingFunction || mathAlgorithms.linear;

        var start = Date.now();
        var scrolledElement = this[0];
        var fromXPosition = scrolledElement.scrollLeft;
        var fromYPosition = scrolledElement.scrollTop;

        if (XAxisPosition === null) {
            XAxisPosition = fromXPosition;
        }

        if (YAxisPosition === null) {
            YAxisPosition = fromYPosition;
        }

        if (!duration) {
            scrolledElement.scrollLeft = XAxisPosition;
            scrolledElement.scrollTop = YAxisPosition;
            callback && callback();
            return;
        }

        if (fromXPosition === XAxisPosition && fromYPosition === YAxisPosition) {
            callback && callback();
            return;
        }

        function scroll() {
            var currentTime = Date.now();
            var timeLeft = Math.min(1, (currentTime - start) / duration);

            scrolledElement.scrollLeft = easingFunction(timeLeft) * (XAxisPosition - fromXPosition) + fromXPosition;
            scrolledElement.scrollTop = easingFunction(timeLeft) * (YAxisPosition - fromYPosition) + fromYPosition;

            if (timeLeft < 1) {
                window.requestAnimationFrame(scroll);
            } else {
                callback && callback();
            }
        }

        window.requestAnimationFrame(scroll);

        return this;
    };

    Deferred.installInto($);

    module.exports = $;
});
